<template>
  <b-button
    id="default-cancel-btn"
    :variant="stageBack ? 'outline-dark' : 'outline-danger'"
  >
    <div class="d-flex align-items-center">
      <span>{{ btnLabel }}</span>
    </div>
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";
export default {
  components: {
    BButton,
  },
  props: {
    btnLabel: { type: String, default: "Cancel" },
    stageBack: { type: Boolean, default: false },
  },
};
</script>

<style>
#default-cancel-btn.btn-outline-danger,
#default-cancel-btn.btn-outline-dark {
  background: white !important;
}

#default-cancel-btn.btn-outline-dark {
  border: 1px solid #a3a3a3 !important;
  color: #a3a3a3 !important;
}

#default-cancel-btn.btn-outline-dark:hover {
  background: #c7cfce1f !important;
}

#default-cancel-btn.btn-outline-danger:hover {
  background: #ea54551f !important;
}
</style>
